module.exports = __webpack_public_path__ + "assets/img/szjz_4.87b34167.png";